import vsf, { definePage } from '@vs/vsf-boot';
import {
  Section,
  VSFormItem,
  VSControlledForm,
  VSFormLayout,
} from '@vs/vsf-kit';
import React, { useRef } from 'react';
import getOssPolicy from '@/utils/getOssPolicy';
import BraftEditor from 'braft-editor';
const ActivitiesForm = (props) => {
  return (
    <Section>
      <VSControlledForm
        vsid="84289"
        layout="inline"
        id="ActivitiesForm"
        value={props.value}
        style={{ marginTop: 20 }}
      >
        <VSFormLayout key="0" columnCount={1} labelWidth={100}>
          <VSFormItem
            name={['actName']}
            label="活动名称"
            valueType="text"
            rules={[{ message: '请输入活动名称' }]}
            fieldProps={{
              maxLength: 20,
            }}
          />

          <VSFormItem
            name={['activityImg']}
            label="活动图片"
            required
            valueType="fileUpload"
            rules={[{ required: true, message: '请上传活动图片' }]}
            convertValue={(v) => {
              try {
                if (!v) {
                  return v;
                }
                if (Array.isArray(v)) {
                  return v?.map((vv) => {
                    if (typeof vv === 'string') {
                      return { url: vv };
                    }
                    return vv;
                  });
                }

                const _v = JSON.parse(v);
                return _v?.map((vv) => {
                  if (typeof vv === 'string') {
                    return { url: vv };
                  }
                  return vv;
                });
              } catch (error) {
                return [];
              }
            }}
            transform={(v) => {
              if (typeof v === 'string' && v?.includes('[')) {
                return {
                  activityImg: v,
                };
              }
              return {
                activityImg: JSON.stringify(
                  v?.map((vv) => {
                    return vv.url;
                  }),
                ),
              };
            }}
            fieldProps={{
              type: 'picture',
              getOssPolicy: getOssPolicy,
              limit: 700 * 900,
              onLimitOverflow: (fileSize, limit) => {
                vsf.showToast('图片尺寸过大', 'error');
              },
              uploadProps: {
                // maxCount: 1,
                accept: '.jpg,.png,.jpeg',
              },
            }}
          />

          <div className="suggessSize" style={{ marginLeft: '100px' }}>
            建议尺寸：700 * 300
          </div>

          {/* <VSFormItem
            name={['activityText']}
            label="活动内容"
            valueType="textarea"
            rules={[{ max: 250, message: '请输入活动内容（250字以内）' }]}
            fieldProps={{
              maxLength: 250,
              autoSize: {
                minRows: 3,
                maxRows: 4,
              },
            }}
          /> */}

          <VSFormItem
            name="activityText"
            label="活动内容"
            valueType="editor"
            required
            rules={[{ required: true, message: '请填写活动内容' }]}
          />

          {/* <VSFormItem
            name={['activityUrl']}
            label="跳至页面"
            valueType="text"
            fieldProps={{}}
          /> */}
        </VSFormLayout>
      </VSControlledForm>
    </Section>
  );
};
export default definePage(ActivitiesForm);
